import type { Cart } from "./Cart.js";
import { CartStep, cartStepArray } from "./CartStep.js";
import { getCantPayOnlineReasons } from "./getCantPayOnDeliveryReason.js";

export function cartWithAppliedProperties<T extends Cart>(cart: T): T {
	const currentCartStep = cartStepArray.indexOf(cart.step);

	const cantPayOnlineReasons = getCantPayOnlineReasons(cart.order);
	if (cantPayOnlineReasons.length > 0) {
		// TODO Condition that OnDelivery payment type is not selected
		if (cart.order.payment?.type !== undefined) {
			cart.order.payment.type = undefined;

			if (currentCartStep > cartStepArray.indexOf(CartStep.PaymentDelivery)) {
				cart.step = CartStep.PaymentDelivery;
			}
		}
	}

	return {
		...cart,
		properties: {
			cantPayOnlineReasons,
		},
	};
}
